import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

const statuses = [
    'Pending', 'Approved', 'Rejected', 'Error', 'Uploaded'
  ];

  
  // Status -> pill variant (ui-kit.css's .ex-status-*). Same labels as before.
  const STATUS_VARIANTS = {
    Pending: '',
    Approved: 'ex-status-info',
    Rejected: 'ex-status-danger',
    Error: 'ex-status-danger',
    'Mapper Error': 'ex-status-danger',
    Uploaded: 'ex-status-success',
  };

  const StatusPill = ({ status }) => (
    <span className={`ex-status ${STATUS_VARIANTS[status] || ''}`.trim()}>{status}</span>
  );

  const statusItemTemplate = (option) => <StatusPill status={option} />

  const dataTypeItemTemplate = (option) => {
        return (<span>{option.value}</span>)
  }
  let data_types = [
    { id: 1, name: 'SME Loans', value: 'SME' },
    { id: 2, name: 'Consumer Loans', value: 'CONSUMER' },
    { id: 3, name: 'ECS Portfolio', value: 'ECS' },
    { id: 4, name: 'Cash Flows', value: 'CASH_FLOWS' },
    { id: 5, name: 'Opportunities', value: 'OPPORTUNITIES' },
    {  id: 6, name: 'Loan Applications', value: 'APPLICATIONS' },
    {  id: 7, name: 'Invoices', value: 'INVOICE_FINANCING' }
  ]
  const dataTypeFilterTemplate = (options) => {
    return <Dropdown value={options.value} optionValue="value" optionLabel="value"  options={data_types} 
    onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={dataTypeItemTemplate} placeholder="Select a Status" className="p-column-filter" showClear />;
  }

export const FILE_UPLOAD_COLUMNS = [
    {
        header: 'Name',
        field: 'file_name',
        sortable:true,
        filter: true,
        // A long file name was the column that kept forcing this table
        // wider than its container (same overflow issue the ReqID column
        // below already had, fixed the same way) - truncated to one line
        // with the full name still available via the title tooltip.
        style: { maxWidth: '16rem' },
        body: (rowData) => (
            <span title={rowData.file_name} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>{rowData.file_name}</span>
        )
    },
    {
        header: 'Uploaded',
        field: 'upload_date',
        dataType:"date",
        sortable:true,
        filter: true,
        filterField:"upload_date",
        style:{ minWidth: '12rem' },
        body: (rowData) => {
            return rowData.upload_date.toLocaleString('en-GB', {
                weekday: "short",
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                timezone: 'Europe/Berlin'
            });;
            // return rowData.upload_date.toString();
        },
        filterElement: (options) => {
            return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />
          }
    },
    {
        header: 'Number Of Rows',
        field: 'num_of_rows',
        sortable:true,
        filter:true,
        dataType:"numeric",
        style: { maxWidth: '7rem' }
    },
    {
        
        header: 'Data Type',
        field: 'data_type',
        sortable:true,
        filter:true,
        filterElement:dataTypeFilterTemplate,
        filterField:"data_type"
    },
    {
        
        header: 'Uploaded By',
        field: 'uploaded_by_user_email',
        sortable:true,
        filter:false
    },
    {
        header: 'Status',
        field: 'status',
        sortable:true,
        filter:true,
        filterField:"status",
        filterElement: (options) => {
    return <Dropdown  value={options.value} options={statuses} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={statusItemTemplate} placeholder="Select a Status" className="p-column-filter" showClear />;
  },
        body: rowData => <StatusPill status={rowData.status} />
    }
]
